<template>
  <div
    class="flex flex-col sm:flex-row sm:items-center gap-2 bg-gray-50 dark:bg-gray-800 p-2 sm:p-1 rounded-lg border border-gray-200 dark:border-gray-700"
  >
    <div class="flex items-center gap-1">
      <USelect v-model="startMonth" :items="months" class="flex-1 sm:w-24" size="xs" variant="none" />
      <USelect v-model="startYear" :items="years" class="flex-1 sm:w-20" size="xs" variant="none" />
    </div>
    <span class="hidden sm:inline text-gray-400 text-xs">-</span>
    <div class="flex items-center gap-1">
      <USelect v-model="endMonth" :items="months" class="flex-1 sm:w-24" size="xs" variant="none" />
      <USelect v-model="endYear" :items="years" class="flex-1 sm:w-20" size="xs" variant="none" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, watch, onMounted, computed } from 'vue'

const props = withDefaults(
  defineProps<{
    modelValue: { start: string; end: string }
    minYear?: number
  }>(),
  {
    minYear: 2015,
  },
)

const emit = defineEmits(['update:modelValue'])

const months = [
  { label: 'Januar', value: '01' },
  { label: 'Februar', value: '02' },
  { label: 'März', value: '03' },
  { label: 'April', value: '04' },
  { label: 'Mai', value: '05' },
  { label: 'Juni', value: '06' },
  { label: 'Juli', value: '07' },
  { label: 'August', value: '08' },
  { label: 'September', value: '09' },
  { label: 'Oktober', value: '10' },
  { label: 'November', value: '11' },
  { label: 'Dezember', value: '12' },
]

const currentYear = new Date().getFullYear()
const years = computed(() => {
  const start = props.minYear
  const length = currentYear - start + 2
  return Array.from({ length }, (_, i) => ({
    label: (start + i).toString(),
    value: (start + i).toString(),
  }))
})

const startMonth = ref('01')
const startYear = ref(currentYear.toString())
const endMonth = ref('12')
const endYear = ref(currentYear.toString())

const parseValue = (val: string) => {
  if (!val) return null
  const [year, month] = val.split('-')
  return { year, month }
}

onMounted(() => {
  const start = parseValue(props.modelValue.start)
  if (start) {
    startYear.value = start.year
    startMonth.value = start.month
  }
  const end = parseValue(props.modelValue.end)
  if (end) {
    endYear.value = end.year
    endMonth.value = end.month
  }
})

watch([startMonth, startYear, endMonth, endYear], () => {
  emit('update:modelValue', {
    start: `${startYear.value}-${startMonth.value}`,
    end: `${endYear.value}-${endMonth.value}`,
  })
})

watch(
  () => props.modelValue,
  (newVal) => {
    const start = parseValue(newVal.start)
    if (start && (start.year !== startYear.value || start.month !== startMonth.value)) {
      startYear.value = start.year
      startMonth.value = start.month
    }
    const end = parseValue(newVal.end)
    if (end && (end.year !== endYear.value || end.month !== endMonth.value)) {
      endYear.value = end.year
      endMonth.value = end.month
    }
  },
  { deep: true },
)
</script>
